import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AuthEffects } from '../effects/auth.effects';
import { AuthBusinessProfilesEffects } from '../effects/business-profiles.effects';
import { authFeatures } from './auth-features';

export { authFeatures, type AuthState } from './auth-features';

export function provideAuthState(): EnvironmentProviders[] {
  return [
    importProvidersFrom(StoreModule.forFeature(authFeatures.name, authFeatures.reducer), EffectsModule.forFeature([AuthEffects, AuthBusinessProfilesEffects]))
  ];
}
